import { render, staticRenderFns } from "./createBiaoge.vue?vue&type=template&id=1ea3e928&"
import script from "./createBiaoge.vue?vue&type=script&lang=js&"
export * from "./createBiaoge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports